import { Avatar, Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent } from 'react';

import { BackButton } from './BackButton';
import { DATA_HOOKS } from '../../dataHooks';

import css from './index.module.scss';

type MyProfileProps = {
  name: string;
  joined: string;
  customerId: string;
  profileImage?: string;
};

export const MyProfile: FunctionComponent<MyProfileProps> = ({
  name,
  joined,
  customerId,
  profileImage,
}: MyProfileProps) => {
  const { t } = useTranslation();

  return (
    <Box direction="vertical" className={css.wrapper}>
      <BackButton />
      <Heading
        className={css.myProfileTitle}
        dataHook={DATA_HOOKS.MY_PROFILE_HEADING}
      >
        {t('user-profile.title')}
      </Heading>
      <Box
        flexWrap="wrap"
        verticalAlign="top"
        className={css.contentWrapper}
        gap="10px"
      >
        <Box direction="horizontal" className={css.avatarWrapper}>
          <Avatar
            size="size72"
            name={name}
            imgProps={{ src: profileImage }}
            className={css.avatar}
            dataHook={DATA_HOOKS.MY_PROFILE_AVATAR}
          />
        </Box>
        <Box
          className={css.detailsWrapper}
          direction="vertical"
          verticalAlign="top"
        >
          <Heading
            className={css.profileName}
            dataHook={DATA_HOOKS.MY_PROFILE_NAME}
            size="large"
          >
            {name}
          </Heading>

          <Box
            dataHook={DATA_HOOKS.MY_PROFILE_JOINED}
            direction="horizontal"
            align="left"
            marginTop="3px"
          >
            <Text className={css.fieldName}>{t('user-profile.joined')}:</Text>
            <Text className={css.fieldNameVal}>{joined}</Text>
          </Box>

          <Box
            dataHook={DATA_HOOKS.MY_PROFILE_CUSTOMER_ID}
            direction="horizontal"
            align="left"
          >
            <Text className={css.fieldName}>
              {t('user-profile.customerId')}:
            </Text>
            <Text className={css.fieldNameVal}>{customerId}</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
